
let subjects = []
let next = null

let scrollPos = -1
let hasScrolled = false


const scrolled = function() {

    if ( !hasScrolled ) {
        hasScrolled = true
        next( recalcAll )
    }

}

const recalcAll = function() {

    const newScrollPos = window.pageYOffset;

    if ( newScrollPos !== scrollPos ) {

        scrollPos = newScrollPos
        subjects.forEach( recalc )

        next( recalcAll )

    } else {
        hasScrolled = false
    }

}

const recalc = function( subject ) {

    if ( subject.shouldRecalc ) {

        const update = calcPosition( subject )
        if ( update.progress !== subject.previousProgress ) {
            subject.callback(update, subject.el)
            subject.previousProgress = update.position
        }

    } else {
        subject.callback({ scroll: scrollPos }, subject.el)
    }

}

function getYOffset( el ) {
    let y = 0
    while( el && !isNaN( el.offsetTop ) ) {
        y += el.offsetTop
        el = el.offsetParent
    }
    return y
}


function getCachedTop(subject, forceRecalc) {

    if ( forceRecalc || subject.cachedTop == null ) {
        subject.cachedTop = getYOffset(subject.el)
    }

    return subject.cachedTop

}

/**
 * Calculates new position of given subject
 * @param  {Object} subject the subject to process
 * @return {Object} {
 *                      progress: Number ( 0 on bottom, 1 on top),
 *                      fromTop: Number (el distance from top of viewport),
 *                      fromBottom: Number (el distance from bottom of viewport),
 *                      scroll: Number (global scroll position)
 *                  }
 */
function calcPosition( subject ) {

    const el = subject.el,
        viewportTop = scrollPos,
        viewportHeight = window.innerHeight,
        viewportBottom = viewportTop + viewportHeight,
        elTop = getCachedTop(subject),
        elHeight = el.offsetHeight,
        elBottom = elTop + elHeight


    // 0 if element top is on viewport bottom
    // 1 if element bottom is on viewport top
    const positioning = ( viewportBottom - elTop ) / ( viewportHeight + elHeight )

    const fromTop = elTop - viewportTop
    const fromBottom = viewportBottom - elBottom

    return { progress: Math.max(0, Math.min( positioning, 1) ), fromTop: fromTop, fromBottom: fromBottom, scroll: scrollPos }
}


/**
 * Adds a new subject to control
 * On update the callback is called with two parameters ( { progress: Number, fromTop: Number, fromBottom: Number, scroll: Number }, el)
 *
 * @param  {DOM}   el         the DOM element to watch
 * @param  {Function} callback   the function to call when el updates
 * @param  {boolean}   skipRecalc  only subscribe to global scroll updates, not interested in element specific position (default: false)
 */
export default function(el, callback, skipRecalc) {

    if ( el == null ) {
        return
    }

    subjects.push({ el: el, callback: callback, shouldRecalc: !skipRecalc })

    if ( !next ) {

        // initialize

        window.addEventListener('scroll', scrolled)

        next = window.requestAnimationFrame ||
             window.webkitRequestAnimationFrame ||
             window.mozRequestAnimationFrame ||
             window.msRequestAnimationFrame ||
             window.oRequestAnimationFrame ||
             function(cb) { window.setTimeout(cb, 1000/60) }

    }

    // fire at least once
    scrolled()

}



// WEBPACK FOOTER //
// ./resources/assets/js/web/scroll-control.js